import React from 'react'
import { Router as ReachRouter } from '@reach/router'

import Show from './show'

const Router = props => {
  return (
    <ReachRouter primary={false} style={{ width: '100%' }}>
      <Show {...props} path=":guideSlug/*" />
    </ReachRouter>
  )
}

export default Router
